import { Alert } from '../_functions'
import * as FilePond from 'filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import fr_fr from 'filepond/locale/fr-fr.js';

FilePond.setOptions(fr_fr);
FilePond.registerPlugin(FilePondPluginFileValidateType);

document.addEventListener('DOMContentLoaded', function(dom) {
  const object = vnObject

  const pond = FilePond.create(dom.target.querySelector('.filepond-specifications'), {
    acceptedFileTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    fileValidateTypeLabelExpectedTypesMap: {
      'application/pdf': '.pdf',
      'application/msword': '.doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    },
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
  });

  const form = dom.target.querySelector('.contact-form')

  if (form) {

    form.addEventListener('submit', function(e) {
      e.preventDefault()
      e.stopPropagation()

      if (form.checkValidity()) {
        const formData = new FormData(form)
        formData.append('action', 'vn_contact')

        var pondFiles = pond.getFiles();
        if ( pondFiles[0] ) {
          formData.append('specifications', pondFiles[0].file);
        }

        const options = {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        }

        fetch(object.ajaxUrl, options)
          .then((response) => response.json())
          .then((res) => {
            form.classList.remove('sending')

            if (res.success && res.data.redirect) {
              window.location = res.data.redirect
            }

            Alert(res.success, res.data.message)

            if (res.success) {
              form.reset()
            }
          })
          .catch((error) => {
            form.classList.remove('sending')
            console.error('Erreur:', error)
          })

        form.classList.add('sending')
        Alert(false, object.formWait)
      } else {
        form.classList.add('was-validated')
      }
    })
  }

  const subjectSelect = dom.target.querySelector("#subject");
  const specifications = dom.target.querySelector(".js-specifications");
  const quoteOption = dom.target.querySelector("#quote");

  function toggleSpecifications() {
    if ( quoteOption ) {
      if (quoteOption.selected) {
        specifications.style.display = "block";
      } else {
        specifications.style.display = "none";
      }
    }
  }

  if ( subjectSelect ) {
    subjectSelect.addEventListener("change", toggleSpecifications);
  }

  // Pour gérer l'état au chargement de la page
  toggleSpecifications();
})
